// ============================================
// SPANISH TRANSLATIONS
// ============================================

export const es = {
    // Common selects
    selectCountry: '-- Seleccionar País --',
    selectState: '-- Seleccionar Estado --',
    select: '-- Seleccionar --',

    // Add more translations as needed
} as const;
